import { Theme } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

export const useDotLegalDialogStyles = makeStyles((theme: Theme) => ({
    dialogContent: {
        padding: "8px 48px",
    },
    dialogCloseButton: {
        color: theme.customPalette.darkBlue,
        "&:hover": {
            backgroundColor: "unset",
        },
    },
    header: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
        display: "flex",
        justifyContent: "center",
        marginBottom: theme.spacing(1),
        color: theme.palette.primary.dark,
        fontSize: theme.typography.pxToRem(14),
        fontWeight: theme.typography.fontWeightBold,
        textTransform: "uppercase",
    },
    actions: {
        justifyContent: "center",
    },
}));

export default useDotLegalDialogStyles;
